import { FORM_SCHEMA_TYPES as TYPES } from "../formSchemaTypes";
import { get } from "lodash";

const TRAVEL_RESONS = {
  "TO SET UP INDUSTRIAL/BUSINESS VENTURE":
    "TO SET UP INDUSTRIAL/BUSINESS VENTURE",
  "SALE/PURCHASE/TRADE": "SALE/PURCHASE/TRADE",
  "ATTEND TECHNICAL/BUSINESS MEETINGS": "ATTEND TECHNICAL/BUSINESS MEETINGS",
  "CONDUCTING TOURS": "CONDUCTING TOURS",
  "TO DELIVER LECTURE/S UNDER GLOBAL INITIATIVE FOR ACADEMIC NETWORKS (GIAN)":
    "TO DELIVER LECTURE/S UNDER GLOBAL INITIATIVE FOR ACADEMIC NETWORKS (GIAN)",
  "PLI/SPECS/EMC 2.0 SCHEME": "PLI/SPECS/EMC 2.0 SCHEME",
  "SPORTS RELATED ACTIVITY": "SPORTS RELATED ACTIVITY",
  "TO JOIN THE VESSEL": "TO JOIN THE VESSEL",
  "TOURISM,RECREATION,SIGHT-SEEING": "TOURISM,RECREATION,SIGHT-SEEING",
  "MEETING FRIENDS/RELATIVES": "MEETING FRIENDS/RELATIVES",
  "SHORT TERM YOGA PROGRAMME": "SHORT TERM YOGA PROGRAMME",
  "SHORT TERM COURSES ON LOCAL LANGUAGES, MUSIC, DANCE, ARTS & CRAFTS, COOKING, MEDICINE ETC. WHICH SHOULD NOT BE A FORMAL OR STRUCTURED COURSE/PROGRAMME (COURSES NOT EXCEEDING 6 MONTHS DURATION AND NOT ISSUED WITH A QUALIFYING CERTIFICATE/ DIPLOMA ETC)":
    "SHORT TERM COURSES ON LOCAL LANGUAGES, MUSIC, DANCE, ARTS & CRAFTS, COOKING, MEDICINE ETC. WHICH SHOULD NOT BE A FORMAL OR STRUCTURED COURSE/PROGRAMME (COURSES NOT EXCEEDING 6 MONTHS DURATION AND NOT ISSUED WITH A QUALIFYING CERTIFICATE/ DIPLOMA ETC)",
  "VOLUNTARY WORK OF SHORT DURATION (FOR A MAXIMUM PERIOD OF ONE MONTH, WHICH DO NOT INVOLVE ANY MONETARY PAYMENT OR CONSIDERATION OF ANY KIND IN RETURN)":
    "VOLUNTARY WORK OF SHORT DURATION (FOR A MAXIMUM PERIOD OF ONE MONTH, WHICH DO NOT INVOLVE ANY MONETARY PAYMENT OR CONSIDERATION OF ANY KIND IN RETURN)",
};

export const IND_SELECT_VALUES = {
  GENDERS: "GENDERS_NEW",
  RELIGIONS: "RELIGIONS",
  EDUCATION: "EDUCATION",
  MARITAL_STATUS: "MARITAL_STATUS_NEW",
  OCCUPATION: "OCCUPATION_NEW",
  OLD_VISA_TYPE: "OLD_VISA_TYPE",
  STATES: "STATES",
  DISTRICTS: "DISTRICTS",
  VISA_TYPES: "VISA_TYPES",
  TOURIST_VALIDITY: "TOURIST_VALIDITY",
  TOURIST_TRAVEL_REASON: "TOURIST_TRAVEL_REASON",
  BUSINESS_TRAVEL_REASON: "BUSINESS_TRAVEL_REASON",
  // VISA_SUB_TYPES: "VISA_SUB_TYPES",
  EXIT_PORT: "EXIT_PORT",
  ARRIVAL_PORT: "ARRIVAL_PORT",
  PASSPORT_TYPE: "PASSPORT_TYPE",
  NATIONALITY_ACQUIRE: "NATIONALITY_ACQUIRE",
  NATIONALITY: "NATIONALITY",
  FAMILY_NATIONALITY: "FAMILY_NATIONALITY",
  SAARC_COUNTRIES: "SAARC_COUNTRIES",
  COUNTRIES: "COUNTRIES_NEW",
  LAST_10_YEAR_COUNTRIES: "LAST_10_YEAR_COUNTRIES",
  VISA_HOLDER_IDENTIFICATION_TYPE: "VISA_HOLDER_IDENTIFICATION_TYPE",
  VESSEL_TYPE: "VESSEL_TYPE",
  EVENT_TYPE: "EVENT_TYPE",
  COMPANY_NAMES: "COMPANY_NAMES",
  CAPACITY: "CAPACITY",
  CAPACITY_TYPE: "CAPACITY_TYPE",
  OCCUPATION_SPECIFY: "OCCUPATION_SPECIFY",
  POINTS_OF_ENTRY: "POINTS_OF_ENTRY",
  NATIONALITY_ACQUISITION: "NATIONALITY_ACQUISITION",
  SECURITY_QUESTIONS: "SECURITY_QUESTIONS",
};

export const indSchemaNew = {
  generalInfoSegment: {
    label: "General application information",
    type: TYPES.SEGMENT,
    initialOpen: true,
    data: {
      _id: {
        label: "ID",
      },
      isFullyFilled: {
        label: "Form fully filled",
      },
      siteId: {
        label: "Referral Site",
      },
      orderId: {
        label: "Order ID",
      },
      orderIdHistory: {
        label: "Order ID History",
      },
      invoiceEmail: {
        label: "Payment email",
      },
      zendeskId: {
        label: "Zendesk ID",
        type: TYPES.TEXT,
        required: false,
      },
      userLanguage: {
        label: "User form language",
      },
      userCountry: {
        label: "Users IP country",
      },
      botRuns: {
        label: "Number of bot runs",
      },
    },
  },
  personalInfoSegment: {
    label: "Personal information",
    type: TYPES.SEGMENT,
    data: {
      firstName: {
        label: "First name",
        type: TYPES.TEXT,
      },
      lastName: {
        label: "Last name",
        type: TYPES.TEXT,
      },
      hasNameChanged: {
        label: "User has other alias",
        type: TYPES.CHECKBOX,
      },
      previousGivenName: {
        label: "Additional first name",
        type: TYPES.TEXT,
        dependsOn: "hasNameChanged",
      },
      previousSurname: {
        label: "Additional last name",
        type: TYPES.TEXT,
        dependsOn: "hasNameChanged",
      },
      userEmail: {
        label: "User contact email",
        type: TYPES.EMAIL,
      },
      submissionEmail: {
        label: "Email used to submit user to eta",
        type: TYPES.EMAIL,
      },
      gender: {
        label: "Gender",
        type: TYPES.SELECT,
        values: IND_SELECT_VALUES.GENDERS,
      },
      maritalStatus: {
        label: "Marital status",
        type: TYPES.SELECT,
        values: IND_SELECT_VALUES.MARITAL_STATUS,
      },
      maritalStatusOther: {
        label: "Describe other marital status",
        type: TYPES.TEXT,
        dependsOn: "maritalStatus",
        dependantOnValues: ["Other"],
      },
      spouse: {
        label: "Spouse",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "maritalStatus",
        dependantOnValues: ["Married"],
        nested: {
          spouseGivenName: {
            label: "First name",
            type: TYPES.TEXT,
          },
          spouseSurname: {
            label: "Last name",
            type: TYPES.TEXT,
          },
          spouseNationality: {
            label: "Nationality",
            type: TYPES.SELECT,
            values: IND_SELECT_VALUES.COUNTRIES,
          },
          spouseDateOfBirth: {
            label: "Date of birth",
            type: TYPES.DATE,
          },
          spouseCityOfBirth: {
            label: "City of birth",
            type: TYPES.TEXT,
          },
        },
      },
    },
  },
  birthInfoSegment: {
    label: "Birth information",
    type: TYPES.SEGMENT,
    data: {
      dateOfBirth: {
        label: "Date of Birth",
        type: TYPES.DATE,
      },
      birthCountry: {
        label: "Birth country",
        type: TYPES.SELECT,
        values: IND_SELECT_VALUES.COUNTRIES,
      },
      birthCity: {
        label: "Birth city",
        type: TYPES.TEXT,
      },
      religion: {
        label: "Religion",
        type: TYPES.TEXT,
      },
    },
  },
  contactInfoSegment: {
    label: "Contact information",
    type: TYPES.SEGMENT,
    data: {
      residenceCountry: {
        label: "Residence country",
        type: TYPES.SELECT,
        values: IND_SELECT_VALUES.COUNTRIES,
      },
      stateProvinceRegion: {
        label: "State / Province / Region",
        type: TYPES.TEXT,
      },
      city: {
        label: "City",
        type: TYPES.TEXT,
      },
      postalCode: {
        label: "Postal / ZIP code",
        type: TYPES.TEXT,
      },
      phoneNumber: {
        label: "Phone number",
        type: TYPES.TEXT,
      },
      residenceAddress: {
        label: "Address",
        type: TYPES.TEXT,
      },
    },
  },
  visaInformationSegment: {
    label: "Visa information",
    type: TYPES.SEGMENT,
    data: {
      passportInformation: {
        label: "Passport information",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          nationalityOnPassport: {
            label: "Nationality",
            type: TYPES.SELECT,
            values: IND_SELECT_VALUES.COUNTRIES,
          },
          passportNumber: {
            label: "Passport number",
            type: TYPES.TEXT,
          },
          countryOfIssue: {
            label: "Country of issue",
            type: TYPES.SELECT,
            values: IND_SELECT_VALUES.COUNTRIES,
          },
          placeOfIssue: {
            label: "Place of issue",
            type: TYPES.TEXT,
          },
          dateOfIssue: {
            label: "Date of issue",
            type: TYPES.DATE,
          },
          passportExpirationDate: {
            label: "Expiration date",
            type: TYPES.DATE,
          },
          nationalityAcquisition: {
            label: "How did you acquire nationality?",
            type: TYPES.SELECT,
            values: IND_SELECT_VALUES.NATIONALITY_ACQUISITION,
          },
          originalCountry: {
            label: "Other value",
            type: TYPES.SELECT,
            dependsOn: "nationalityAcquisition",
            dependantOnValues: ["By naturalization"],
            values: IND_SELECT_VALUES.COUNTRIES,
          },
          livedInCountryForTwoYears: {
            label:
              "Has user lived for at least 2 years in the country where he/she is applying for a visa?",
            type: TYPES.CHECKBOX,
          },
          hasOtherPassport: {
            label:
              "Does user hold any other valid passport or Identity Certificate (IC)?",
            type: TYPES.CHECKBOX,
          },
          otherPassportDetails: {
            label: "Other passport details",
            type: TYPES.NESTED,
            newTable: true,
            dependsOn: "hasOtherPassport",
            dependantOnValues: [true],
            nested: {
              otherCountryOfIssue: {
                label: "Country of issue",
                type: TYPES.SELECT,
                values: IND_SELECT_VALUES.COUNTRIES,
                path: "otherPassportDetails",
              },
              otherPassportNumber: {
                label: "Passport number",
                type: TYPES.TEXT,
                path: "otherPassportDetails",
              },
              otherPlaceOfIssue: {
                label: "Place of issue",
                type: TYPES.TEXT,
                path: "otherPassportDetails",
              },
              otherDateOfIssue: {
                label: "Date of issue",
                type: TYPES.DATE,
                path: "otherPassportDetails",
              },
              otherNationality: {
                label: "Nationality",
                type: TYPES.SELECT,
                values: IND_SELECT_VALUES.COUNTRIES,
                path: "otherPassportDetails",
              },
            },
          },
        },
      },
      travelInformation: {
        label: "Travel information",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          visaType: {
            label: "Visa type",
            type: TYPES.SELECT,
            values: IND_SELECT_VALUES.VISA_TYPES,
          },
          validity: {
            label: "Validity",
            type: TYPES.SELECT,
            values: IND_SELECT_VALUES.TOURIST_VALIDITY,
          },
          mainTravelReason: {
            label: "Main travel reason",
            type: TYPES.SELECT,
            values: TRAVEL_RESONS,
          },
          travelDate: {
            label: "Travel date",
            type: TYPES.DATE,
          },
          pointOfEntry: {
            label: "Point of entry",
            type: TYPES.SELECT,
            values: IND_SELECT_VALUES.POINTS_OF_ENTRY,
          },
        },
      },
    },
  },
  familyInfoSegment: {
    label: "Family information",
    type: TYPES.SEGMENT,
    data: {
      fatherNotApplicable: {
        label: "Father not applicable",
        type: TYPES.CHECKBOX,
      },
      fatherInfo: {
        label: "Father information",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "fatherNotApplicable",
        dependantOnValues: [false],
        nested: {
          fatherGivenName: {
            label: "First name",
            type: TYPES.TEXT,
          },
          fatherSurname: {
            label: "Last name",
            type: TYPES.TEXT,
          },
          fatherNationality: {
            label: "Nationality",
            type: TYPES.SELECT,
            values: IND_SELECT_VALUES.COUNTRIES,
          },
          fatherCountryOfBirth: {
            label: "Country of birth",
            type: TYPES.SELECT,
            values: IND_SELECT_VALUES.COUNTRIES,
          },
        },
      },
      fatherDetails: {
        label: "",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "fatherNotApplicable",
        dependantOnValues: [true],
        nested: {
          fatherDetails: {
            label: "Details",
            type: TYPES.TEXT,
          },
        },
      },
      motherNotApplicable: {
        label: "Mother not applicable",
        type: TYPES.CHECKBOX,
      },
      motherInfo: {
        label: "Mother information",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "motherNotApplicable",
        dependantOnValues: [false],
        nested: {
          motherGivenName: {
            label: "First name",
            type: TYPES.TEXT,
          },
          motherSurname: {
            label: "Last name",
            type: TYPES.TEXT,
          },
          motherNationality: {
            label: "Nationality",
            type: TYPES.SELECT,
            values: IND_SELECT_VALUES.COUNTRIES,
          },
          motherCountryOfBirth: {
            label: "Country of birth",
            type: TYPES.SELECT,
            values: IND_SELECT_VALUES.COUNTRIES,
          },
        },
      },
      motherDetails: {
        label: "",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "motherNotApplicable",
        dependantOnValues: [true],
        nested: {
          motherDetails: {
            label: "Details",
            type: TYPES.TEXT,
          },
        },
      },
      emergencyContact: {
        label: "Emergency contact",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          emergencyContactGivenName: {
            label: "First name",
            type: TYPES.TEXT,
          },
          emergencyContactSurname: {
            label: "Last name",
            type: TYPES.TEXT,
          },
          emergencyContactPhoneNumber: {
            label: "Phone number",
            type: TYPES.TEXT,
          },
          emergencyContactAddress: {
            label: "Address",
            type: TYPES.TEXT,
          },
        },
      },
    },
  },
  workInfoSegment: {
    label: "Work information",
    type: TYPES.SEGMENT,
    data: {
      occupation: {
        label: "Occupation",
        type: TYPES.SELECT,
        values: IND_SELECT_VALUES.OCCUPATION,
      },
      employerName: {
        label: "Employer name / Business",
        type: TYPES.TEXT,
      },
      fieldOfWork: {
        label: "Field of work",
        type: TYPES.TEXT,
      },
      employerAddress: {
        label: "Employer address",
        type: TYPES.TEXT,
      },
      employerPhoneNumber: {
        label: "Employer phone number",
        type: TYPES.TEXT,
      },
      occupationDetails: {
        label: "Occupation details",
        type: TYPES.TEXT,
        dependsOn: "occupation",
        dependantOnValues: ["OTHERS"],
      },
    },
  },
  securityInfoSegment: {
    label: "Security information",
    type: TYPES.SEGMENT,
    data: {
      hasParentalNationality: {
        label:
          "Were your parents/grandparents (paternal/maternal) Pakistan Nationals or belong to Pakistan held area?",
        type: TYPES.CHECKBOX,
      },
      parentalNationalityDetails: {
        label: "If Yes, give details",
        type: TYPES.TEXT,
        dependsOn: "hasParentalNationality",
      },
      hasVisitedChina: {
        label:
          "Have you ever visited People's Republic of China on or after 15 January 2020?",
        type: TYPES.CHECKBOX,
      },
      chinaVisitDetails: {
        label: "If Yes, give details",
        type: TYPES.TEXT,
        dependsOn: "hasVisitedChina",
      },
      hasVisitedIndia: {
        label: "Have you ever been to India before?",
        type: TYPES.CHECKBOX,
      },
      indiaVisitDetails: {
        label: "If Yes, give details",
        type: TYPES.TEXT,
        dependsOn: "hasVisitedIndia",
      },
      hasBeenRefusedEntryIndia: {
        label:
          "Has permission to visit or extend stay in India previously been refused?",
        type: TYPES.CHECKBOX,
      },
      indiaRefusalDetails: {
        label: "If Yes, give details",
        type: TYPES.TEXT,
        dependsOn: "hasBeenRefusedEntryIndia",
      },
      hasMilitaryAffiliation: {
        label:
          "Are / were you in a military / semi-military / police / security organization?",
        type: TYPES.CHECKBOX,
      },
      militaryInfo: {
        label: "Military info",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "hasMilitaryAffiliation",
        nested: {
          militaryOrganization: {
            label: "Organization",
            type: TYPES.TEXT,
          },
          militaryDesignation: {
            label: "Designation (title)",
            type: TYPES.TEXT,
          },
          militaryRank: {
            label: "Military rank",
            type: TYPES.TEXT,
          },
          militaryPostingPlace: {
            label: "Posting place",
            type: TYPES.TEXT,
          },
        },
      },
      hasBeenArrested: {
        label:
          "Have you ever been arrested / prosecuted / convicted by court of law of any country?",
        type: TYPES.CHECKBOX,
      },
      arrestDetails: {
        label: "If Yes, give details",
        type: TYPES.TEXT,
        dependsOn: "hasBeenArrested",
      },
      hasBeenDeported: {
        label:
          "Have you ever been refused entry / departed by any country including India?",
        type: TYPES.CHECKBOX,
      },
      deportationDetails: {
        label: "If Yes, give details",
        type: TYPES.TEXT,
        dependsOn: "hasBeenDeported",
      },
      hasIllegalActivities: {
        label: "Have you ever been engaged in illegal activities?",
        type: TYPES.CHECKBOX,
      },
      illegalActivitiesDetails: {
        label: "If Yes, give details",
        type: TYPES.TEXT,
        dependsOn: "hasIllegalActivities",
      },
      hasCybercrimeInvolvement: {
        label:
          "Have you ever been engaged in cyber crime / terrorist activities / sabotage / espionage / genocide / political killing / other act of violence?",
        type: TYPES.CHECKBOX,
      },
      cybercrimeDetails: {
        label: "If Yes, give details",
        type: TYPES.TEXT,
        dependsOn: "hasCybercrimeInvolvement",
      },
      intendsToVisitJammuKashmir: {
        label: "Whether you intend to visit Jammu & Kashmir?",
        type: TYPES.CHECKBOX,
      },
      jammuKashmirVisitDetails: {
        label: "If Yes, give details",
        type: TYPES.TEXT,
        dependsOn: "intendsToVisitJammuKashmir",
      },
      bornInJammuKashmir: {
        label:
          "Do you or your parents by birth belong to any part of Jammu & Kashmir?",
        type: TYPES.CHECKBOX,
      },
      jammuKashmirBirthDetails: {
        label: "If Yes, give details",
        type: TYPES.TEXT,
        dependsOn: "bornInJammuKashmir",
      },
      migratedToPakistan: {
        label:
          "Have you migrated from India to Pakistan on or after 1st March 1947?",
        type: TYPES.CHECKBOX,
      },
      migrationDetails: {
        label: "If Yes, give details",
        type: TYPES.TEXT,
        dependsOn: "migratedToPakistan",
      },
      countriesVisitedInLastTenYears: {
        label: "Countries visited in last 10 years",
        type: TYPES.MULTI_SELECT,
        values: IND_SELECT_VALUES.COUNTRIES,
      },
    },
  },
  consent_and_declaration: {
    label: "Consent and Declaration",
    type: TYPES.SEGMENT,
    data: {
      securityQuestion: {
        label: "Security question",
        type: TYPES.SELECT,
        values: IND_SELECT_VALUES.SECURITY_QUESTIONS,
      },
      securityAnswer: {
        label: "Security answer",
        type: TYPES.TEXT,
        required: true,
      },
      signature: {
        label: "Signature of applicant",
        type: TYPES.TEXT,
        required: true,
      },
      agreeWithConsent: {
        label: "Consent Declaration",
        type: TYPES.BOOLEAN,
        required: true,
      },
      agreeWithTerms: {
        label: "Terms & Conditions",
        type: TYPES.BOOLEAN,
        required: true,
      },
      parental_consent: {
        label: "Parental Consent (if applicable)",
        type: TYPES.NESTED,
        nested: {
          parentGuardianName: {
            label: "Parent/Guardian Name",
            type: TYPES.TEXT,
          },
          parentGuardianSignature: {
            label: "Signature of parent or guardian",
            type: TYPES.TEXT,
          },
        },
      },
    },
  },
};
